var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 6",
    style: {
      enableBackground: "new 0 0 8 6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4655428,5.6392217L0.2268122,3.4011681c-0.3023839-0.3022923-0.302421-0.792491-0.0000828-1.0948291 l0.0000347-0.0000348c0.3022577-0.3022575,0.7922974-0.3023129,1.0946232-0.000123L3.0128896,3.996922l3.6365321-3.6360939 c0.3023114-0.3022748,0.7924204-0.30226,1.0947132,0.000033l0.0000014,0.0000011 c0.3023162,0.3023161,0.3023038,0.7924709-0.0000262,1.0947725L3.5601802,5.6391649 C3.2579024,5.9414139,2.7678518,5.9414392,2.4655428,5.6392217z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/Ok.917cc5f39896cc6bb7432a64f94f8882.svg";
export { ForwardRef as ReactComponent };